export const resolveComponentUrl = (
	isEditor: boolean,
	isSSR: boolean,
	clientUrl: string,
	editorComponentUrl?: string,
	serverUrl?: string
) => {
	if (isSSR) {
		return serverUrl || clientUrl
	} else if (isEditor) {
		return editorComponentUrl || clientUrl
	}
	return clientUrl
}
